/**
 * The AI draft marks what it could not find with literal text (contract v0.3,
 * section 0): [missing] for data, [not attached yet] for a requested file. The
 * highlight is derived from the text itself, so typing over a placeholder
 * removes it and its highlight together.
 */
export const MISSING = '[missing]';
export const NOT_ATTACHED_YET = '[not attached yet]';

const PLACEHOLDER = /\[missing\]|\[not attached yet\]/g;

export interface PlaceholderRange {
  start: number;
  end: number;
}

export function findPlaceholders(text: string): PlaceholderRange[] {
  return Array.from(text.matchAll(PLACEHOLDER), (match) => ({
    start: match.index ?? 0,
    end: (match.index ?? 0) + match[0].length,
  }));
}

export function countPlaceholders(text: string): number {
  return findPlaceholders(text).length;
}

/** "Keep editing" selects the first placeholder that is left. */
export function firstPlaceholder(text: string): PlaceholderRange | null {
  return findPlaceholders(text)[0] ?? null;
}

/**
 * Attaching a file removes the matching [not attached yet]. The draft does not
 * say which file each one stands for, so the first one goes.
 */
export function removeFirstNotAttachedYet(text: string): string {
  const index = text.indexOf(NOT_ATTACHED_YET);
  if (index === -1) return text;
  const before = text.slice(0, index);
  const after = text.slice(index + NOT_ATTACHED_YET.length);
  // Do not leave a double space behind ("is  attached" -> "is attached").
  return /\s$/.test(before) && /^\s/.test(after)
    ? before + after.replace(/^\s/, '')
    : before + after;
}
